import type { ReactNode } from 'react';

import style from './style.css';

export interface IBuildingMainBlockProps {
  header: ReactNode;
  /** Галерея, описание, застройщик и УК */
  left: ReactNode;
  /** Характеристики и ставки; ниже — блоки задач 5–7 */
  right: ReactNode;
}

/** Сетка основного блока как на проде: шапка на всю ширину, ниже широкая левая и узкая правая колонки */
export const BuildingMainBlock = ({ header, left, right }: IBuildingMainBlockProps) => (
  <section className={style['container']} id="about" data-name="BuildingMainBlock">
    {header}
    <div className={style['columns']}>
      <div className={style['left']}>{left}</div>
      <div className={style['right']}>{right}</div>
    </div>
  </section>
);
